export const INITIAL_MESSAGE = 'INITIAL_MESSAGE';